<template>
  <div class="bg-brand-taupe-500">
    <PageHeader :headingContent="headingContent" />
    <div class="pb-20">
      <div class="container mx-auto mb-4 rounded-md bg-brand-taupe-100 p-6">
        <template v-if="!displayConfirmation && this.showform">
          <div class="px-4 gap-4">
            <p class="mb-4">
              If you need to reset your password just enter your email address, please use
              the one you were invited with. We'll then send you an email with a link to a
              page where you can set a new password for your account.
            </p>
          </div>
          <form class="px-4 flex flex-wrap gap-4" @submit.prevent autocomplete="off">
            <div class="flex flex-wrap items-center w-full">
              <div class="w-1/3">
                <label for="email" class="font-semibold text-brand-blue-400">Email</label>
              </div>
              <div class="w-2/3">
                <input
                  class="w-full border-gray-300 px-2 py-1 bg-white-100 border-2"
                  id="email"
                  type="text"
                  v-model="form.email"
                  autocomplete="off"
                />
              </div>
              
              <div
                v-if="$attrs.errors.email"
                class="border-2 w-full px-2 py-1 text-gray-900 text-sm mt-8 bg-[#D6F5D6]"
              >
                {{ $attrs.errors.email }}
              </div>
            </div>
            <div class="flex justify-end w-full">
              <button
                class="bg-brand-blue-400 hover:bg-brand-blue-200 text-white font-bold py-2 px-4 mr-2 rounded uppercase"
                @click="submitForm()"
              >
                Send reset link
              </button>
            </div>
          </form>
        </template>
        <div v-else>
          <h2 class="text-xl font-bold">Password Reset Link Sent</h2>
          <p class="border-2 w-full px-2 py-1 text-gray-900 text-sm mt-2 bg-[#D6F5D6]">
            We’ve sent a password reset link to your email. Please check your inbox (and spam folder) to proceed with resetting your password. The link will expire in 60 minutes. If you don’t receive the email, try again or contact our support team for help.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/Shared/PageHeader";
import { useForm } from "@inertiajs/inertia-vue3";

export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      displayConfirmation: false,
      showform: true,
      form: useForm({
        email: "",
      }),
      headingContent: {
        hero: {
          image: "/images/263918963_cars_hero.jpg",
          title: "Fleet Risk Review",
          subtitle: "In association with AXA Insurance",
        },
        page: {
          title: "Forgot Your Password?",
          subtitle: "",
        },
      },
    };
  },
  methods: {
    submitForm() {
      this.form.post("/forgot-password", {
        onSuccess: () => {
          this.displayConfirmation = true;
          this.showform = false;
          this.form.reset();
        },
        onError: (errors) => {
          this.showform = false;
        },
        preserveState: true,
      });
    },
  },
};
</script>
